// extracted by mini-css-extract-plugin
export var modalFooter = "_s7-0";